<template>
  <section class="relative">
    <nuxt-img class="absolute inset-0 top-0 object-cover w-full h-full" width="1150" height="695" preload fetchpriority="high"
      loading="eager" format="webp"
      sizes="sm:400px md:100vw lg:100vw xl:1150px" alt="bg-hero" :src=backgroundImageHero
      :style="{ filter: `brightness(${backgroundImageBrightness})` }"></nuxt-img>

    <div class="relative pt-10 px-14 sm-max:px-4 sm-max:pt-4 md-only:pt-4 pb-14 sm-max:pb-2 z-1 md-max:mt-2">

      <div class="py-5 mb-8" :style="{ background: backgroundColorExtraTitle }"
         :class="{ 'hidden': !extraTitleVisibility }">
        <h2 v-html="extraTitleText"
          class="lg:text-51 md:text-42 text-22 max-w-3xl m-auto text-center font-bold leading-6 md:leading-10 lg:leading-[54px]">

        </h2>
      </div>



      <h1 class="pt-0 mb-6 text-center text-headTitle leading-head text-h1 sm-max:text-22">
        <strong v-html="HeroTitle"> </strong>
      </h1>
      <ul class="pl-12 space-y-0 list-disc sm-max:pl-10 pb-7">
        <li v-for="(item, index) in HeroList" :key="index" class="text-sm lg:text-21 md:text-lg md:leading-8"
          v-html="item.text">
        </li>
      </ul>

      <div :style="{ background: backgroundUnderTitle }"
        class="p-10 sm-max:p-4 mt-0 text-black bg-[rgba(255,255,255,0.46)] font-roboto md-only:text-2xl sm-max:text-13 lg:text-2xl p-6 border border-[#e7e5e2] text-center">
        <div><em v-html="HeroPromoTextBasic"> </em></div>
      </div>

      <div class="my-4 mt-6" v-if="extraButtonFooter">
        <div class="mb-2 text-center sm-max:leading-3" v-if="extraButtonTopText">
          <span v-html="buttonTextTopBold" class="font-bold sm:text-xl text-12"></span>

          <br class="block sm:hidden">
          <span v-if="!extraButtonBottomText" class="italic sm:text-base text-12" v-html="buttonTextTopSmall"></span>
        </div>
        <ButtonHealty :scrollTrigger :text="buttonText" :data-event-label="'btnHeroCta'" :data-event-action="'Click: Save 50% Now'" :data-event-name="'experiment_event'" />


        <div v-if="extraButtonBottomText" class="mt-1 italic text-center sm:text-base text-12"
          v-html="buttonTextTopSmall">

        </div>
      </div>


    </div>
  </section>
</template>


<script setup>

defineProps({
  extraTitleVisibility: {
    type: Boolean,
    default: false
  },
  extraTitleText: {
    type: String,
    default: 'LIMITED TIME FALL SPECIAL SAVINGS'
  },
  backgroundColorExtraTitle: {
    type: String,
    default: ''
  },
  backgroundImageHero: {
    type: String,
    default: '/assets/images/5z1M2bpX_2x.jpg',
  },
  backgroundImageBrightness: {
    type: Number,
    default: 1
  },
  HeroTitle: {
    type: String,
    default: 'Secure Your Supply of Our Delicious, Immune-Boosting, Low-Acid Healthy Coffee 50% OFF Today While Supplies Last',
  },
  HeroList: {
    type: Array,
    default: () => [
      { text: 'Non-GMO, single-origin, USDA-certified organic coffee' },
      { text: 'pH test proven to be up to 27.7% less acidic than common store-bought coffees' },
      { text: 'Shade-grown & sun-dried high in the mountains of Central America' },
      { text: 'Fairly traded, tested for pesticide, & chemical, pure antioxidant-rich coffee' },
      { text: '2-year shelf life' },
      { text: 'No lines, no rationing - delivered directly to your door' },
      // Add more default items here...
    ],
  },
  HeroPromoTextBasic: {
    type: String,
    default: '“The coffee is amazing. I had stopped drinking coffee because of certain side effects I was feeling after drinking it. This coffee didn\'t seem to create any of those problems for me. The flavor is amazing and the coloring - WOW.” - S. Vagivagi',
  },

  backgroundUnderTitle: {
    type: String,
    default: 'rgba(255,255,255,0.46)'
  },
  extraButtonFooter: {
    type: Boolean,
    default: false
  },
  buttonText: {
    type: String,
    default: 'SAVE 50% NOW'
  },
  extraButtonTopText: {
    type: Boolean,
    default: false
  },
  buttonTextTopBold: {
    type: String,
    default: 'LIMITED TIME OFFER: Get 50% off your first order (discount auto-applied)'
  },
  buttonTextTopSmall: {
    type: String,
    default: '(discount auto-applied)'
  },
  extraButtonBottomText: {
    type: Boolean,
    default: false
  },
  scrollTrigger: {
    type: String,
    default: "the-products"
  }
})


defineBuilderComponent(  {
    friendlyName: 'Hero',
    canHaveChildren: true,
    inputs: [
      { name: 'extraTitleVisibility', type: 'boolean', defaultValue: false },
      {
        name: 'extraTitleText',
        type: 'richText',
        defaultValue: 'LIMITED TIME FALL SPECIAL SAVINGS',
      },
      {
        name: 'backgroundColorExtraTitle',
        type: 'color',
        defaultValue: ''
      },
      { name: 'backgroundImageHero', type: 'file', defaultValue: '/assets/images/5z1M2bpX_2x.jpg' },
      { name: 'backgroundImageBrightness', type: 'number', defaultValue: 1, min: 0, max: 1, step: 0.01 },
      {
        name: 'HeroTitle',
        type: 'richText',
        defaultValue: 'Secure Your Supply of Our Delicious, Immune-Boosting, Low-Acid Healthy Coffee 50% OFF Today While Supplies Last'
      },
      {
        name: 'HeroList',
        type: 'list',
        subFields: [
          { name: 'text', type: 'richText' }
        ],
        defaultValue: [
          { text: 'Non-GMO, single-origin, USDA-certified organic coffee' },
          { text: 'pH test proven to be up to 27.7% less acidic than common store-bought coffees' },
          { text: 'Shade-grown &amp; sun-dried high in the mountains of Central America' },
          { text: 'Fairly traded, tested for pesticide, & chemical, pure antioxidant-rich coffee' },
          { text: '2-year shelf life' },
          { text: 'No lines, no rationing - delivered directly to your door' },
          // Add more default items here...
        ]
      },
      {
        name: 'HeroPromoTextBasic',
        type: 'richText',
        defaultValue: '“The coffee is amazing. I had stopped drinking coffee because of certain side effects I was feeling after drinking it. This coffee didn\'t seem to create any of those problems for me. The flavor is amazing and the coloring - WOW.” - S. Vagivagi'
      },
      { name: 'backgroundUnderTitle', type: 'color', defaultValue: 'rgba(255,255,255,0.46)' },
      { name: 'extraButtonFooter', type: 'boolean', defaultValue: false },
      {
        name: 'buttonText',
        type: 'text',
        defaultValue: 'SAVE 50% NOW'
      },
      { name: 'extraButtonTopText', type: 'boolean', defaultValue: false },
      {
        name: 'buttonTextTopBold',
        type: 'richText',
        defaultValue: 'LIMITED TIME OFFER: Get 50% off your first order'
      },
      {
        name: 'buttonTextTopSmall',
        type: 'richText',
        defaultValue: '(discount auto-applied)'
      },
      { name: 'extraButtonBottomText', type: 'boolean', defaultValue: false },
      { name: 'scrollTrigger', type: 'string', defaultValue: "the-products" }

    ],
  })
</script>
